// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input-checkbox {
  position: relative;
  display: block;
  padding: 15px 0 12px 50px;
  margin: 20px 0;
}
input-checkbox label input {
  position: absolute;
  opacity: 0;
}
input-checkbox label input:checked ~ span {
  border-radius: 5px;
  -webkit-transform: rotate(0deg) scale(1);
  -ms-transform: rotate(0deg) scale(1);
  transform: rotate(0deg) scale(1);
  opacity: 1;
}
input-checkbox label input:checked ~ span::after {
  -webkit-transform: rotate(45deg) scale(1);
  -ms-transform: rotate(45deg) scale(1);
  transform: rotate(45deg) scale(1);
  opacity: 1;
  left: 9px;
  top: 5px;
  width: 6px;
  height: 12px;
  border-radius: 0;
}
input-checkbox label span.answer {
  position: absolute;
  cursor: pointer;
  top: 50%;
  margin-top: -15px;
  left: 5px;
  padding: 0;
  width: 30px;
  height: 30px;
  transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
}
input-checkbox label span.answer::after {
  position: absolute;
  content: "";
  top: 15px;
  left: 15px;
  height: 0;
  width: 0;
  border: solid #000;
  border-width: 0 3px 3px 0;
  opacity: 1;
  -webkit-transform: rotate(0deg) scale(0);
  -ms-transform: rotate(0deg) scale(0);
  transform: rotate(0deg) scale(0);
  transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
}
input-checkbox label span.answer::before {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/resources/elements/input-checkbox/input-checkbox.scss","webpack://./src/style/mixins.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;AADJ;AAIQ;EACI,kBAAA;EACA,UAAA;AAFZ;AAKgB;EACI,kBAAA;ECsBlB,wCDrBqC;ECsBrC,oCDtBqC;ECuBrC,gCDvBqC;EACnB,UAAA;AADpB;AAIgB;ECiBd,yCDhBqC;ECiBrC,qCDjBqC;ECkBrC,iCDlBqC;EACnB,UAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AAApB;AAKQ;EACI,kBAAA;EACA,eAAA;EACA,QAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;ECXV,6BDY8B;ECX9B,qCDW8B;ECV9B,kCDU8B;ECT9B,iCDS8B;ECR9B,gCDQ8B;AAChC;AACY;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;ECfd,wCDgBiC;ECfjC,oCDeiC;ECdjC,gCDciC;ECxBjC,6BDyBkC;ECxBlC,qCDwBkC;ECvBlC,kCDuBkC;ECtBlC,iCDsBkC;ECrBlC,gCDqBkC;AAOpC;AAJY;EACI,aAAA;AAMhB","sourcesContent":["@import \"../../../style/mixins.scss\";\n\ninput-checkbox {\n    position: relative;\n    display: block;\n    padding: 15px 0 12px 50px;\n    margin: 20px 0;\n\n    label {\n        input {\n            position: absolute;\n            opacity: 0;\n\n            &:checked {\n                ~span {\n                    border-radius: 5px;\n                    @include transform(rotate(0deg) scale(1));\n                    opacity: 1;\n                }\n        \n                ~span::after {\n                    @include transform(rotate(45deg) scale(1));\n                    opacity: 1;\n                    left: 9px;\n                    top: 5px;\n                    width: 6px;\n                    height: 12px;\n                    border-radius: 0;\n                }\n            }\n        }\n\n        span.answer {\n            position: absolute;\n            cursor: pointer;\n            top: 50%;\n            margin-top: -15px;\n            left: 5px;\n            padding: 0;\n            width: 30px;\n            height: 30px;\n            @include transition(all 0.3s ease-out);\n\n            &::after {\n                position: absolute;\n                content: \"\";\n                top: 15px;\n                left: 15px;\n                height: 0;\n                width: 0;\n                border: solid #000;\n                border-width: 0 3px 3px 0;\n                opacity: 1;\n                @include transform(rotate(0deg) scale(0));\n                @include transition(all 0.3s ease-out);\n            }\n\n            &::before {\n                display: none;\n            }\n        }\n    }\n}","﻿@mixin breakpoint($point) {\n  @if $point == desktop {\n    @media (min-width: 1281px) {\n      @content;\n    }\n  }\n  @else if $point == laptop {\n    @media (min-width: 1024px) {\n      @content;\n    }\n  }\n  @else if $point == tablet {\n    @media (min-width: 768px) {\n      @content;\n    }\n  }\n  @else if $point == phablet {\n    @media (min-width: 481px) {\n      @content;\n    }\n  }\n  @else if $point == mobile {\n    @media (min-width: 320px) {\n      @content;\n    }\n  }\n}\n\n@mixin transition($value) {\n  transition: $value;\n  -webkit-transition: $value;\n  -moz-transition: $value;\n  -ms-transition: $value;\n  -o-transition: $value;\n}\n\n@mixin transform($value) {\n  -webkit-transform: $value;\n  -ms-transform: $value;\n  transform: $value;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
